import { createSelector } from 'reselect';
import memoize from 'lodash/memoize';

import {
  ILoadedNoteflowTasksAction,
  NoteflowTaskActions,
  NoteflowTaskActionTypes
} from '../actions/noteflowTaskActions';

import { ApiStatus } from '../../models';
import { IState } from './index';

export const initialNoteflowTaskState: INoteflowTaskState = {
  loadingStatus: null,
  tasks: null,
};

export interface INoteflowTaskState {
  loadingStatus: ApiStatus | null;
  tasks: any[] | null;
}

export default function noteflowTaskReducer(
  state: INoteflowTaskState = initialNoteflowTaskState,
  action: NoteflowTaskActions
): INoteflowTaskState {
  switch (action.type) {
    case NoteflowTaskActionTypes.LOAD_NOTEFLOW_TASKS:
      return {
        ...state,
        loadingStatus: ApiStatus.LOADING,
      }
    case NoteflowTaskActionTypes.LOADED_NOTEFLOW_TASKS:
      return handleLoadedNoteflowTasks(state, action);
    default:
      return state;
  }
}

// Functions

function handleLoadedNoteflowTasks(state: INoteflowTaskState, action: ILoadedNoteflowTasksAction) {
  return {
    ...state,
    tasks: action.payload.result, // TODO: append, not replace
    loadingStatus: ApiStatus.LOADED,
  }
}

// Selectors

export const noteflowTasksSelector = memoize((flowRunId: string | null | undefined) => createSelector(
  (state: IState) => state.noteflowTask.tasks,
  (results: any[] | null): any | null => {
    /*
     * results are appended to the beginning of the list, so first result is the last added
     */
    return results?.filter(
      (result: any) => result?.flow_run_id === flowRunId) || null;
  },
));
